import styled from "styled-components";

export const CardArea = styled.div`
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
`;

export const TitleDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 10px 10px 0px 0px;
`;

export const TitleText = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
`;

export const TitleIcon = styled.div`
  display: flex;
  padding: 6px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 14px;
  background: rgba(107, 101, 222, 0.1);
  color: #6b65de;
  font-family: Pretendard;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 10px; /* 100% */
`;

export const ContentBody = styled.div`
  display: flex;
  padding: 0px 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  align-self: stretch;
`;

export const FlexDiv = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`;

export const TextTitle = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
`;

export const TextContent = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
`;

export const CommentDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: #888;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`;

export const Button = styled.div`
  display: flex;
  height: ${(props) => (props.height ? props.height : "48px")};
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;
  border-radius: 6px;
  background: ${(props) => (props.color === "true" ? "#6B65DE" : "#f4f4f4")};
  color: ${(props) => (props.color === "true" ? "#FFFFFF" : "#666666")};
`;

export const SeparateLine = styled.div`
  align-self: stretch;
  border: 0.5px solid #eee;
`;